import React, { Component } from 'react';
// import TextTruncate from 'react-text-truncate';
// import Truncate from 'react-truncate';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import { Card, Grid, Image, Button, Icon, Popup, Divider } from 'semantic-ui-react';
import _ from 'lodash';
import SocialTable from '../social-table';

const cardContent = {
  paddingBottom: 18,
};

const handleStyle = {
  marginBottom: 0,
};

const buttonStyles = {
  width: '150px',
};

const influencerBioStyles = {
  height: '150px',
};

const approvalStyles = {
  height: '150px',
};

const countryStyles = {
  height: '1rem',
};

const countryMap = {
  GB: 'United Kingdom',
  US: 'United States',
  TR: 'Turkey',
  DE: 'Germany',
  FR: 'France',
  CA: 'Canada',
  AU: 'Australia',
};

const APPROVAL_DISPLAY_LIMIT = 2;

class InfluencerShortlistCard extends Component {
  getMediaLink = () => {
    const { influencer, organisation } = this.props;
    return `${_.get(organisation, 'mediaKitUrl')}/media-kit/${influencer.id}`;
  }

  hasMediaKit = () => {
    const { organisation } = this.props;
    return _.get(organisation, 'mediaKitUrl');
  }

  handleApprove = () => {
    const { influencer, onApprove } = this.props;
    onApprove({ name: 'John Doe' }, influencer.id);
  }

  handleReject = () => {
    const { influencer, onReject } = this.props;
    onReject({ name: 'John Doe' }, influencer.id);
  }


  render = () => {
    const { influencer, dataNode, description, isShortlistApprovalDisabled, selectedPlatforms } = this.props;

    const popupHtml = `<b>${influencer.name}'s Bio</b><br><br>${(dataNode && dataNode.description ? dataNode.description : description)}` || '-';
    const approvalHtml = limit => ((dataNode && dataNode.approvals) ? _.map(_.take(dataNode.approvals, limit || dataNode.approvals.length), (approval, idx) => (
      <p key={idx}>{approval.message}&nbsp;
        {
          approval.type === 'APPROVE'
            ? <Icon name="thumbs outline up" color="green" />
            : <Icon name="thumbs outline down" color="red" />
        }
      </p>)) : 'No Approvals');

    return (
      <Card
        fluid
      >
        <Card.Content style={cardContent} verticalAlign="middle">
          <Grid padded="horizontally">
            <Grid.Row verticalAlign="middle">
              <Grid.Column width={16} textAlign="center">
                <div>
                  <Image
                    src={influencer.thumbnail}
                    shape="circular"
                    size="small"
                  />
                </div>
              </Grid.Column>
              <Divider />
              <Grid.Column width={16} textAlign="center">
                <h3 style={handleStyle}>
                  {influencer.name}
                </h3>
                <p className="small light" style={countryStyles}>{countryMap[influencer.country] || influencer.country}</p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
        <Card.Content>
          <SocialTable influencer={influencer} selectedPlatforms={selectedPlatforms} />
        </Card.Content>
        <Card.Content style={influencerBioStyles}>
          <h3>
            Influencer Bio
          </h3>
          <HTMLEllipsis
            unsafeHTML={(dataNode && dataNode.description ? dataNode.description : description)}
            maxLine="3"
            ellipsis="..."
            basedOn="letters"
          />
          <Popup
            trigger={<a>View full bio</a>}
            wide="very"
            on="click"
            content={<div dangerouslySetInnerHTML={{ __html: popupHtml }} />}
          />
        </Card.Content>
        { this.hasMediaKit() &&
        <Card.Content>
          <h3>
              Influencer Media Card
          </h3>
          <p>
            <a href={this.getMediaLink()} target="_blank" rel="noopener noreferrer">Click here to see influencer's key data</a>
          </p>
        </Card.Content>}
        { !isShortlistApprovalDisabled && <Card.Content>
          <Button content="approve" icon="thumbs up" floated="right" basic positive style={buttonStyles} onClick={this.handleApprove} />
          <Button content="reject" icon="thumbs down" floated="right" basic negative style={buttonStyles} onClick={this.handleReject} />
        </Card.Content>}
        { !isShortlistApprovalDisabled && <Card.Content style={approvalStyles}>
          <h3>
              Approvals
          </h3>
          {approvalHtml(APPROVAL_DISPLAY_LIMIT)}
          { dataNode && dataNode.approvals && dataNode.approvals.length > APPROVAL_DISPLAY_LIMIT && <Popup
            trigger={<a>View all approvals</a>}
            wide="very"
            on="click"
            content={approvalHtml()}
          />}
        </Card.Content>}

      </Card>
    );
  }
}

export default InfluencerShortlistCard;



// WEBPACK FOOTER //
// ./src/components/influencer-shortlist-card/index.js